
import * as types from '../mutation-types'
import Vue from 'vue'
import regions from '@/api/regions'

const state = {
  provinces: [],
  regions: []
}

const getters = {
  regions: (state) => {
    return state.regions
  },
  provinces: (state) => {
    return state.provinces
  },
  province: (state) => (id) => {
    return state.provinces[id] ? state.provinces[id] : null
  }
}

// actions
const actions = {
  getRegions ({ commit }) {
    commit(types.CLEAR_PROVINCES_AND_REGIONS)
    return new Promise((resolve, reject) => {
      regions.getRegions().then((response) => {
        const provinces = response.data.result.provinces
        provinces.forEach((province) => {
          commit(types.ADD_PROVINCE, province)
        })
        resolve(regions)
      }, (error) => {
        reject(error)
      })
    })
  },
  addRegionBanner ({ commit }, { newBanner, provinceIndex, regionIndex }) {
    commit(types.ADD_BANNER, { newBanner, provinceIndex, regionIndex })
  },
  addRegionSponsors ({ commit }, { newSponsors, provinceIndex, regionIndex }) {
    newSponsors.forEach(newSponsor => {
      commit(types.ADD_SPONSOR, { newSponsor, provinceIndex, regionIndex })
    })
  },
  deleteRegionBanner ({ commit }, { provinceIndex, regionIndex, bannerIndex }) {
    commit(types.DELETE_BANNER, { provinceIndex, regionIndex, bannerIndex })
  },
  deleteRegionSponsor ({ commit }, { provinceIndex, regionIndex, sponsorIndex }) {
    commit(types.DELETE_SPONSOR, { provinceIndex, regionIndex, sponsorIndex })
  },
  addProjectToRegion ({ commit }, { projectID, regionID }) {
    return new Promise((resolve, reject) => {
      regions.addProjectToRegion(projectID, regionID).then((response) => {
        resolve()
      }, (error) => {
        reject(error)
      })
    })
  },
  updateRegionLogo ({ commit }, data) {
    return new Promise((resolve, reject) => {
      regions.updateLogo(data).then((response) => {
        commit(types.UPDATE_REGION_INFO, response.data.result.region)
        resolve(response.data.result)
      }, (error) => {
        reject(error)
      })
    })
  }
}

const mutations = {
  [types.ADD_PROVINCE] (state, province) {
    Vue.set(state.provinces, province.id, province)
    province.regions.forEach((region) => {
      state.regions.push(region)
    })
  },
  [types.CLEAR_PROVINCES_AND_REGIONS] (state) {
    state.provinces = []
    state.regions = []
  },
  [types.ADD_BANNER] (state, params) {
    const provinceBanners = state.provinces[params.provinceIndex].regions[params.regionIndex].banners
    Vue.set(provinceBanners, provinceBanners.length, params.newBanner)
  },
  [types.ADD_SPONSOR] (state, params) {
    const provinceSponsors = state.provinces[params.provinceIndex].regions[params.regionIndex].sponsors
    Vue.set(provinceSponsors, provinceSponsors.length, params.newSponsor)
  },
  [types.DELETE_BANNER] (state, params) {
    Vue.delete(state.provinces[params.provinceIndex].regions[params.regionIndex].banners, params.bannerIndex)
  },
  [types.DELETE_SPONSOR] (state, params) {
    Vue.delete(state.provinces[params.provinceIndex].regions[params.regionIndex].sponsors, params.sponsorIndex)
  },
  [types.UPDATE_REGION_INFO] (state, newRegion) {
    state.provinces[newRegion.provinceDetailsID].regions.forEach((region, index) => {
      if (newRegion.id === region.id) {
        state.provinces[newRegion.provinceDetailsID].regions[index].image = newRegion.image
      }
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
